import React from 'react'
import _ from 'lodash'
import ArrowForward from '@mui/icons-material/ArrowForward'
import { store } from 'src/App'
import { path } from 'src/constants/path'
import { closeDialog, openErrorDialog } from 'src/redux/slices/alertDialog'
import { reStartETestingModule } from 'src/redux/slices/eLearning/learning'
import { handleError409 } from 'src/redux/slices/eLearning/learning/events'
import { setSectionTesting } from 'src/redux/slices/eTesting'
import { startLoading, stopLoading } from 'src/redux/slices/loading'
import { getETestingScore } from 'src/services/eTesting'

export const handleGetScore = (props, isModule) => async (dispatch) => {
  const { uuid, trainingPlan, error, history } = props

  if (_.isNil(error)) {
    let body = {
      courseTestUuid: uuid,
      trainingPlanUuid: trainingPlan || '',
    }
    if (isModule) {
      const { selectedLesson, eLearningCourseBatchLearner } =
        store.getState().eLearningLearning
      body = {
        eTestingUuid: _.get(selectedLesson, 'eTestingUuid', ''),
        eLearningModule: _.get(selectedLesson, 'eLearningModule', {}),
        eLearningLessonRefModule: _.get(
          selectedLesson,
          'eLearningLessonRefModule',
          {}
        ),
        eLearningCourseBatchLearner,
      }
    }
    dispatch(startLoading())
    const response = await dispatch(getETestingScore({ body, isModule }))
    dispatch(stopLoading())
    if (isModule) {
      if (response.error) {
        dispatch(handleModuleGetScoreError(response))
      } else {
        if (response.payload?.data?.isNotPass) {
          dispatch(
            openErrorDialog({
              title: 'ไม่ผ่านการอบรม',
              message: [
                'เนื่องจากคุณทำข้อสอบไม่ผ่านเกินจำนวนครั้งที่กำหนด',
                'กรุณาลงทะเบียนใหม่ในรอบอบรมถัดไป',
              ],
              buttonRight: {
                label: 'สรุปผลการเรียน',
                endIcon: <ArrowForward />,
                handleClick: () => {
                  const { eLearningCourseBatchLearner } = store.getState().eLearningLearning
                  window.location.href = `${path.myClassELearning}/${eLearningCourseBatchLearner.uuid}`
                },
              },
            })
          )
        }
      }
    }
  } else {
    isModule
      ? dispatch(handleError409({ error }))
      : dispatch(
          openErrorDialog({
            title: _.get(error, 'title', 'ไม่สามารถทำข้อสอบได้'),
            message: [_.get(error, 'value', '')],
            buttonRight: {
              handleClick: () => {
                dispatch(closeDialog())
                if (!isModule) history.push('/my-class')
              },
            },
          })
        )
  }
}

export const handleModuleGetScoreError = (response) => (dispatch) => {
  const error = _.get(response, 'meta.response', _.get(response, 'error', {}))
  const constraints = _.get(
    error,
    'data.constraints',
    _.get(error, 'response.constraints', {})
  )
  const message = _.get(constraints, 'value', ['ดำเนินการไม่สำเร็จ'])

  if (message !== 'ไม่พบข้อมูลการทำแบบทดสอบ') return

  dispatch(
    openErrorDialog({
      iconType: 'error',
      title: _.get(constraints, 'title', 'ผิดพลาด'),
      message,
      buttonRight: {
        handleClick: () => {
          dispatch(reStartETestingModule())
          dispatch(setSectionTesting())
          dispatch(closeDialog())
        },
      },
    })
  )
}
